// extracted by mini-css-extract-plugin
export default {"firstBox":"Filter_firstBox__X0NVz","inputBox":"Filter_inputBox__qiwIp"};